import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { server } from './global.service';
import { server_ip } from '../../../environments/environment';

var header = {
  Accept: "application/json",
  "Content-Type": "application/json",
}


@Injectable({
  providedIn: 'root'
})


export class user_service {
  constructor(private backend: server) { }

  user_list(page,size,filterText,status):Observable<any> {
    return this.backend.get(server_ip + "/list_of_users?page="+page+"&size="+size+"&filter="+filterText+"&approvalStatus="+status)
  }

  getProfileList(consoleOrgId):Observable<any>{
   return this.backend.get(server_ip + "/profileFromOrganisationId?consoleOrgId="+consoleOrgId);
  }

  getCountryDialCode(countryCode):Observable<any>{
    return this.backend.get(server_ip + "/getCountryDialCode?countryCode="+countryCode);
   }

  getOrganisationList():Observable<any>{
    return this.backend.get(server_ip + "/organisations")
  }

  user_login(data):Observable<any> {
    return this.backend.post(server_ip + "/login", data, header)
  }

  

  resetPasswordByAdmin(username):Observable<any> {
    return this.backend.get(server_ip + "/resetUserPassword?username="+username)
  } 

  unlockUser(username):Observable<any>{
    return this.backend.get(server_ip +"/unblockUser?username="+username);
  }

  
  create_user(data):Observable<any> {
    return this.backend.post(server_ip + "/add_user", data, header)
  } 
  checkUserExist(data):Observable<any> {
    return this.backend.get(server_ip + "/checkUserExist?username="+data)
  } 

  get_user_by_id(data):Observable<any> {
    return this.backend.post(server_ip + "/get_user_by_id", data, header)
  } 

 

  get_org_name(data):Observable<any>{
    return this.backend.post(server_ip + "/get_org_name", data, header)

  }


  get_roles(userType):Observable<any> {
    return this.backend.get(server_ip + "/get-roles?userType="+userType)
  }

  
  get_additional_per():Observable<any> {
    return this.backend.get(server_ip + "/get-additional-per")
  }

}
